import { COURSE_GRADE_MAPPING } from './download-documents/constants';

export const getPacingGuideFileName = ({
  courseId,
  stretch,
}: {
  courseId: string;
  stretch?: string | null;
}): string => {
  const grade = COURSE_GRADE_MAPPING[courseId];
  const isKinder = grade === 'K';

  if (!grade) {
    return 'PacingGuide_en_US';
  }

  if (isKinder) {
    return `PacingGuide_${grade}${stretch ? `_S${stretch}` : ''}_en_US`;
  }

  return `Pacing Guide_${grade}${stretch ? `_Stretch ${stretch}` : ''}_en_US`;
};

export const getPersonalizedPracticeFileName = ({
  courseId,
  stretch,
  module,
  hideStandards,
}: {
  courseId: string;
  stretch?: string | null;
  module?: string | null;
  hideStandards?: boolean;
}): string => {
  const grade = COURSE_GRADE_MAPPING[courseId];

  if (!grade) {
    return 'Personalized Practice_en_US';
  }

  return `Personalized Practice_${hideStandards ? '_No_Std_' : ''}${grade}${
    stretch ? `_Stretch ${stretch}` : ''
  }${module ? `_Module ${module}` : ''}_en_US`;
};
